/* ============================================
     "Add 2 / 3 / 4 / 5" shortcuts on the product page.
     Markup: snippets/product-quantity-chips.liquid

     Capture phase on purpose: the theme and custom-atc-transform.js both call
     stopPropagation() on clicks inside the product form, which would kill a
     bubble-phase listener on document.
     ============================================ */

  (function () {
    'use strict';

    // Lets you confirm the file actually loaded: type __qtyChipsLoaded in console.
    window.__qtyChipsLoaded = true;

    document.addEventListener(
      'click',
      function (event) {
        const chip = event.target.closest('[data-qty-chip]');
        if (!chip) return;

        event.preventDefault();
        event.stopPropagation();

        const form = chip.closest('form');
        if (!form) return;

        const submit = form.querySelector('[type="submit"]');
        if (!submit || submit.hasAttribute('disabled')) return;

        const quantity = parseInt(chip.dataset.qtyChip, 10);
        if (!quantity || quantity < 1) return;

        // The quantity field is present but hidden when the merchant turns the
        // stepper off, and absent entirely on some layouts — so make one if needed.
        let input = form.querySelector('[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }

        const previous = input.value || '1';
        input.value = quantity;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submit);
        } else {
          submit.click();
        }

        // ProductForm builds its FormData synchronously inside the submit
        // handler, so restoring on the next tick is safe — and without it the
        // plain "Add to cart" button would keep adding this many.
        setTimeout(function () {
          input.value = previous;
        }, 0);
      },
      true
    );
  })();